import { ITableColumn } from '@components/common/UTable/UTable';

import { TransformedDictionaries } from '@/api/dictionaries/types';
import { Protocol } from '@/api/vaccination/registry/types';
import { EVENT_SOURCE, EventSourceLabel } from '@/shared/vaccination/enums';

const fillColor = (record: Protocol) => {
  if (record.isLateVaccination) {
    return {
      style: {
        backgroundColor: 'rgba(199, 0, 0, 0.2)',
      },
    };
  }
  return {};
};

export const columns = (dictMap: TransformedDictionaries | undefined): ITableColumn[] => [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
    onCell: (record) => fillColor(record),
    render: (_: any, __: any, index: number) => index + 1,
  },
  {
    title: 'Вид исследования, обработки и прививки',
    dataIndex: 'researchTypeId',
    width: 400,
    type: 'select',
    render: (value) => dictMap?.RESEARCH_TYPE?.[value]?.name || '',
    onCell: (record: Protocol) => fillColor(record),
  },
  {
    title: 'Возраст (дней)',
    children: [
      {
        title: 'От',
        dataIndex: 'ageFrom',
        align: 'center',
        onCell: (record: Protocol) => fillColor(record),
      },
      {
        title: 'До',
        dataIndex: 'ageTo',
        align: 'center',
        onCell: (record: Protocol) => fillColor(record),
      },
    ],
  },
  {
    title: 'Возраст на момент обработки (дней)',
    dataIndex: 'vaccinationAge',
    width: 145,
    onCell: (record: Protocol) => fillColor(record),
  },
  {
    title: 'Препарат',
    dataIndex: 'drugName',
    width: 400,
    onCell: (record: Protocol) => fillColor(record),
  },
  {
    title: 'Дозировка',
    dataIndex: 'dosage',
    width: 125,
    onCell: (record: Protocol) => fillColor(record),
  },
  {
    title: 'Дата',
    dataIndex: 'taskDate',
    type: 'date',
    onCell: (record: Protocol) => fillColor(record),
  },
  {
    title: 'Источник',
    dataIndex: 'source',
    type: 'text',
    render: (value: EVENT_SOURCE) => EventSourceLabel?.[value] || '',
    onCell: (record: Protocol) => fillColor(record),
  },
];
